import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Expander from '../Expander';
import { SoftButton } from '../Button';
import Stack from '../Stack';
import styled from 'styled-components';

const Wrapper = styled.div`
    overflow-y: hidden;
    height: ${({ $isExpanded, $minimizedHeight }) =>
        $isExpanded ? 'unset' : $minimizedHeight};
`;

const MinimizedHeightWrapper = styled.div`
    height: ${({ $minimizedHeight }) => $minimizedHeight};
    max-width: 1px;
    position: absolute;
    left: -1000px;
    overflow-y: visible;
    background-color: magenta;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

function OverflowExpander({ children, $minimizedHeight }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const wrapperRef = useRef(null);
    const innerRef = useRef(null);
    const toggleIsExpanded = () => setIsExpanded((prev) => !prev);

    useLayoutEffect(() => {
        setIsOverflowing(
            innerRef.current.offsetHeight > wrapperRef.current.offsetHeight,
        );
    });

    useEffect(() => {
        if (!isOverflowing && isExpanded) {
            setIsExpanded(false);
        }
    }, [isOverflowing, isExpanded, setIsExpanded]);

    return (
        <Stack $space=".625rem">
            <Expander>
                <Wrapper
                    $isExpanded={isExpanded}
                    $minimizedHeight={$minimizedHeight}
                >
                    <MinimizedHeightWrapper
                        $minimizedHeight={$minimizedHeight}
                        ref={wrapperRef}
                    />
                    <div ref={innerRef}>{children}</div>
                </Wrapper>
            </Expander>
            {isOverflowing ? (
                <ButtonWrapper>
                    <SoftButton
                        size="sm"
                        onClick={() => toggleIsExpanded()}
                        IconRight={isExpanded ? FiChevronUp : FiChevronDown}
                    >
                        {isExpanded ? 'Show less' : 'Show more'}
                    </SoftButton>
                </ButtonWrapper>
            ) : null}
        </Stack>
    );
}

export default OverflowExpander;
